import React, { memo } from 'react';
import { Card } from 'tea-component';
// import Iconfont from '@gp/components/Iconfont';
import NoData from '@gp/components/NoData';
import Loading from '@gp/components/Loading';
import TriggerViewCard from '@gp/components/TriggerViewCard';
import StackBarChart from '@gp/pages/StudioDashboard/StudioOverall/components/StackBarChart';
import useFinanceVisualis from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/FinanceVisualis/useFinanceVisualis';
import {
  getBarChartOptionData,
  legendFormatter,
  axisLabelOfXAxisFormatter,
  axisLabelOfYAxisFormatter,
  tootipFormatter,
} from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/FinanceVisualis/utils';
import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/FinanceVisualis/index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import { BASE_ECHART_OPTION, BASE_BAR_SERIES_OPTION } from '@gp/constants/echarts';

const renderChartCompOrNoData = (domain: 'revenue' | 'profit', data: any[]) => {
  const isNoData =
    !Array.isArray(data) ||
    !data?.length ||
    data.every(
      (item) =>
        Number.isNaN(Number.parseFloat(item?.actual)) &&
        Number.isNaN(Number.parseFloat(item?.target)),
    );
  if (isNoData) return <NoData height={262} constomStyle={{ fontSize: 14 }} />;
  return (
    <StackBarChart
      data={data}
      gridConfig={{ top: BASE_ECHART_OPTION?.grid?.top + BASE_BAR_SERIES_OPTION.label?.distance + BASE_BAR_SERIES_OPTION?.label?.fontSize }}
      getBarChartOptionData={getBarChartOptionData}
      legendFormatter={legendFormatter}
      axisLabelOfXAxisFormatter={(name) =>
        axisLabelOfXAxisFormatter(domain, name)
      }
      axisLabelOfYAxisFormatter={axisLabelOfYAxisFormatter}
      tootipFormatter={() => tootipFormatter(domain, data)}
    />
  );
};

const FinanceVisualis: React.FC<IStudioOverallOverviewFinanceVisualisProps> = (
  props,
) => {
  const {
    isLoading: isLoadingProps,
    setFinancialOverviewDataTime,
  } = props;

  const {
    isLoading: isLoadingInner,
    revenueBarChartData,
    profitBarChartData,
  } = useFinanceVisualis({ setFinancialOverviewDataTime });

  const isLoading = isLoadingProps || isLoadingInner;

  const revenueTabs = [
    {
      id: 'chart-bar',
      // label: (
      //   <label onClick={() => {}}>
      //     <Iconfont type="chart-column" className="svgicon" />
      //   </label>
      // ),
      label: null,
      component: renderChartCompOrNoData('revenue', revenueBarChartData),
    },
  ];

  const profitTabs = [
    {
      id: 'chart-bar',
      // label: (
      //   <label onClick={() => {}}>
      //     <Iconfont type="chart-column" className="svgicon" />
      //   </label>
      // ),
      label: null,
      component: renderChartCompOrNoData('profit', profitBarChartData),
    },
  ];

  return (
    <div className="dbg-studio-overall-finance-visualis">
      {isLoading && <Loading loading style={{ height: 320 }} />}
      {isLoading || (
        <>
          <ul className="dbg-studio-overall-finance-chart-list">
            <li className="dbg-studio-overall-finance-chart-item">
              <CardSlot
                className="dbg-finance-budget-trend"
                title="Revenue"
                // defaultActiveId="chart-bar"
                loading={false}
                isNoData={false}
                // tabs={revenueTabs}
              >
                {renderChartCompOrNoData('revenue', revenueBarChartData)}
              </CardSlot>
            </li>
            <li className="dbg-studio-overall-finance-chart-item">
              <CardSlot
                className="dbg-finance-budget-trend"
                title="Profit"
                // defaultActiveId="chart-bar"
                loading={false}
                isNoData={false}
                // tabs={profitTabs}
              >
                {renderChartCompOrNoData('profit', profitBarChartData)}
              </CardSlot>
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

export default memo(FinanceVisualis);
